webpackJsonp([2],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(21),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-monthly-picker',
  props: {
    'value': {
      default: null
    },
    'disabled': {
      type: Boolean,
      default: false
    },
    'inputClass': {
      default: 'input'
    },
    'placeHolder': {
      type: String,
      default: ''
    },
    'alignment': {
      type: String,
      default: 'left',
      validator: function validator(value) {
        // The value must match one of these strings
        return ['left', 'right', 'center'].indexOf(value) !== -1;
      }
    },
    'selectedBackgroundColor': {
      type: String,
      default: '#007bff'
    },
    monthLabels: {
      type: Array,
      default: function _default() {
        return ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
      }
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    dateFormat: {
      type: String,
      default: 'YYYY/MM'
    },
    clearOption: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showMenu: false,
      year: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'),
      month: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM')
    };
  },
  mounted: function mounted() {
    this.init();
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    }
  },
  computed: {
    menuClass: function menuClass() {
      return {
        visible: this.showMenu,
        hidden: !this.showMenu
      };
    },
    menuStyle: function menuStyle() {
      return {
        display: this.showMenu ? 'block' : 'none',
        'left': this.alignment === 'right' ? '100%' : this.alignment === 'center' ? '50%' : '',
        'transform': this.alignment === 'right' ? 'translate(-100%,0)' : this.alignment === 'center' ? 'translate(-50%,0)' : ''
      };
    },
    displayText: function displayText() {
      if (this.value) {
        var valueMoment = null;
        if (typeof this.value === 'string') {
          valueMoment = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value);
        } else {
          valueMoment = this.value;
        }
        if (valueMoment && valueMoment.isValid()) {
          return valueMoment.format(this.dateFormat);
        }
      } else {
        return this.placeHolder;
      }
    },
    canBack: function canBack() {
      if (!this.min) return true;
      var currentVal = this.internalMomentValue.clone().startOf('year');
      return this.min.isBefore(currentVal);
    },
    canNext: function canNext() {
      if (!this.max) return true;
      var currentVal = this.internalMomentValue.clone().endOf('year');
      return currentVal.isBefore(this.max);
    },
    internalMomentValue: function internalMomentValue() {
      var yrMonth = this.year + '/' + this.month;
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(yrMonth, 'YYYY/MM');
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      document.addEventListener('click', function (e) {
        if (_this.$el && !_this.$el.contains(e.target)) {
          _this.closeMenu();
        }
      }, false);
      this.setValue(this.value);
    },
    openMenu: function openMenu() {
      if (!this.disabled) {
        this.showMenu = true;
      }
    },
    closeMenu: function closeMenu() {
      this.showMenu = false;
    },
    prevYear: function prevYear() {
      if (!this.canBack) return;
      var newYear = parseInt(this.year) - 1;
      this.year = newYear.toString();
    },
    nextYear: function nextYear() {
      if (!this.canNext) return;
      var newYear = parseInt(this.year) + 1;
      this.year = newYear.toString();
    },
    selectMonth: function selectMonth(idx) {
      this.month = (parseInt(idx) + 1).toString();
      this.selectPicker();
      this.closeMenu();
    },
    selectPicker: function selectPicker() {
      this.$emit('input', this.internalMomentValue.clone());
      this.$emit('selected', this.internalMomentValue.clone());
    },
    setValue: function setValue(value) {
      if (typeof value === 'string') {
        value = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
      }
      if (value && value.isValid()) {
        this.month = value.format('MM');
        this.year = value.format('YYYY');
      }
    },
    isActive: function isActive(idx) {
      var realMonth = idx + 1;
      var yrMonth = this.year + '/' + (realMonth < 10 ? '0' + realMonth : realMonth);
      if (this.min && __WEBPACK_IMPORTED_MODULE_0_moment___default()(yrMonth, 'YYYY/MM').isBefore(this.min)) {
        return false;
      }
      if (this.max && __WEBPACK_IMPORTED_MODULE_0_moment___default()(yrMonth, 'YYYY/MM').isAfter(this.max)) {
        return false;
      }
      return true;
    },
    isCurrentSelected: function isCurrentSelected(year, monthIdx) {
      if (!this.value) {
        return false;
      }
      var checkValue = this.value;
      if (typeof this.value === 'string') {
        checkValue = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value);
      }
      if (checkValue && checkValue.isValid()) {
        var currentMonth = checkValue.format('MM');
        var currentYear = checkValue.format('YYYY');
        return Number(currentMonth) === Number(monthIdx + 1) && Number(currentYear) === Number(year);
      }
      return false;
    },
    getBackgroundColor: function getBackgroundColor(year, monthIdx) {
      if (this.isCurrentSelected(year, monthIdx)) {
        return this.selectedBackgroundColor;
      }
    },
    clearSelect: function clearSelect() {
      this.$emit('input', null);
      this.$emit('selected', null);
    }
  }
});

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueMonthlyPicker__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueMonthlyPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VueMonthlyPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_lib_scss__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_lib_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_lib_scss__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_VueMonthlyPicker___default.a);

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-monthly-picker"
  }, [_c('div', {
    staticClass: "month-picker-wrapper",
    class: {
      'active visible': _vm.showMenu
    }
  }, [_c('div', {
    staticClass: "month-year-label picker",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "tabindex": "0"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('div', {
    staticClass: "month-year-display",
    class: [_vm.inputClass, {
      'placeholder': !_vm.value
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('div', {
    staticClass: "display-text",
    class: 'display-text-' + _vm.alignment,
    style: ([{
      'text-align': _vm.alignment
    }])
  }, [_vm._v(_vm._s(_vm.displayText))]), _vm._v(" "), (_vm.clearOption && _vm.value) ? _c('span', {
    staticClass: "vmp-input-append",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.clearSelect($event)
      }
    }
  }, [_c('i', {
    staticClass: "vmp-clear-icon"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }), _vm._v(" "), _c('div', {
    staticClass: "date-popover",
    class: _vm.menuClass,
    style: (_vm.menuStyle),
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "picker",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "flexbox"
  }, [_c('span', {
    staticClass: "prev",
    class: {
      deactive: !_vm.canBack
    },
    on: {
      "click": _vm.prevYear
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('span', {
    staticClass: "next",
    class: {
      deactive: !_vm.canNext
    },
    on: {
      "click": _vm.nextYear
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flexbox monthItem"
  }, [_vm._l((_vm.monthLabels), function(month, idx) {
    return [(_vm.isActive(idx)) ? _c('div', {
      key: idx,
      staticClass: "item active",
      class: {
        'selected': _vm.isCurrentSelected(_vm.year, idx)
      },
      style: ([{
        'background-color': _vm.getBackgroundColor(_vm.year, idx)
      }]),
      on: {
        "click": function($event) {
          _vm.selectMonth(idx)
        }
      }
    }, [_vm._v(_vm._s(month) + "\n            ")]) : _c('div', {
      key: idx,
      staticClass: "item deactive",
      class: {
        'selected': _vm.isCurrentSelected(_vm.year, idx)
      }
    }, [_vm._v("\n              " + _vm._s(month) + "\n            ")])]
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[2]);


// WEBPACK FOOTER //
// docs/js/vue-monthly-picker.e8910e0c70f5d78cf796.js